export const queryKeys = {
  all: 'tx-reporting' as const,
  reports: () => [queryKeys.all, 'report'] as const,
  report: (report_date: string) => [queryKeys.all, 'report', { report_date }] as const,
}
